module.exports = __webpack_public_path__ + "img/over-the-city-soldier.d769013d.png";